<script>
import ListingModel from "@/views/Absence/AbsenceRequest/Components/ListingModel.vue";

export default {
    name: "Vacations",
    components: {ListingModel}
}
</script>

<template>
    <ListingModel vacation/>
</template>